import React from 'react';
import './Footerbas.css'; // Assurez-vous d'importer le fichier CSS

const Footerbas = () => {
    return (
        <div className="abas-container">
            <span className="word">Politique de confidentialité</span>
            <span className="word">Mentions légales</span>
            <span className="word">Marchés publics</span>
        </div>
    );
};

export default Footerbas;
